export default {
    appTitle: "Kuusakoski Mobisulo",

    common: {
        cancel: "Peruuta",
        close: "Sulje",
        confirm: "Vahvista",
        next: "Seuraava",
        save: "Tallenna",
        search: "Hae",
        send: "Lähetä",
        error: "Virhe",
    },

    errorDialog: {
        body: "Tapahtui virhe.",
        title: "Virhe"
    },

    navigation: {
        mainView: "Päänäkymä",
        support: "Tuki",
        termsOfUse: "Käyttöehdot",
        dataPrivacy: "Tietosuoja",
        account: "Käyttäjä",
        logOut: "Kirjaudu ulos",
    },

    accountView: {
        email: "Sähköposti",
    },

    addressCard: {
        accessHoursAlways: "Auki 24h",
        navigate: "Navigoi"
    },

    deviationDialog: {
        addDeviation: "Raportoi tehtävästä",
        removeTask: "Poista tehtävä",
        deviationCategory: "Kategoria",
        deviationDescription: "Sisältö",
        saveDeviation: "Tallenna raportti",
        loadedQuantity: "Lastattu määrä",
        plannedQuantity: "Suunniteltu määrä",
        remainingQuantity: "Materiaalia jäi",
        quantityUnit: "Yksikkö",
        fileOptional: "Tiedosto (ei pakollinen)",
        waitingTime: "Odotusaika",
        workTime: "Työaika",
        loadTransportPartsInfo: "Lisää näille nimikkeille epäonnistuneen tehtävän suorittamiseen kohdistuneet kulut. Muista laskea myös nämä kulut mukaan, kuorman päättäville toteumatiedoille.",
        reportHoursInfo: "Lisää näille nimikkeille tuntityöstä aiheutuneet kulut. Muista laskea myös nämä kulut mukaan, kuorman päättäville toteumatiedoille."
    },

    findUnitDialog: {
        findUnit: "Etsi lava",
        unitNumber: "Lavanumero",
    },

    loadExecutionDialog: {
        loadExecutionInfo: "Kuorman toteumatiedot",
        comment: "Kuormaa koskevat lisätiedot",
        commentPlaceholder: "Kirjoita tähän toteumatiedot, jos et voi lisätä niitä yllä oleviin kenttiin."
    },

    loadTransportPartEdit: {
        otherValue: "Muu arvo",
    },

    loadTaskSelect: {
        noLoads: "Ei kuormia",
        selectTask: "Valitse tehtävä",
        transition: "Siirtymä",
    },

    login: {
        authenticationResponse: {
            Error: "Virheellinen sähköpostiosoite tai salasana",
            Unsupported: "Käyttäjän täytyy kirjautua Kuusakosken www-sivuston kautta"
        },

        logIn: "Kirjaudu",
    },

    mainView: {
        incompleteTasksInstructions: "Ajoneuvolla on vanhoja tehtäviä tai kuormia, joita ei ole viety valmiiksi asti. Päivämäärävalinta vaihdettiin automaattisesti.",
        date: "Päivä",
        vehicle: "Ajoneuvo"
    },

    missingUnitDialog: {
        additionalFeatures: "Lisäominaisuudet",
        reportMissingUnit: "Ilmoita puuttuva lava",
        instructions: "Lavaa ei löytynyt hakemallasi lavanumerolla. Tee ilmoitus puuttuvasta lavasta.",
        unitNumber: "Lavanumero",
        unitType: "Lavan tyyppi",
        sideDoors: "Sivuovet",
        sideRelease: "Sivulaukaisu",
        securityChain: "Turvaketju"
    },

    planTaskDialog: {
        loads: "Kuormat",
        task: "Tehtävä",
        planTask: "Suunnittele tehtävä",
        createNewLoad: "Luo uusi kuorma",
        newLoad: "Uusi kuorma",
        addToLoad: "Lisää kuormaan",
        removeFromLoad: "Poista kuormasta",
    },

    planTaskDistanceDialog: {
        distance: "Välimatka",
        end: "Mihin",
        endInput: "Mihin (kaupunki/postinumero)",
        noResults: "Ei tuloksia",
        notes: "Lisätiedot",
        start: "Mistä",
        startInput: "Mistä (kaupunki/postinumero)",
        title: "Välimatkahaku"
    },

    planTaskLoadTransportPartsDialog: {
        transportParts: "Kuljetusnimikkeet",
    },

    taskStartedDialog: {
        selectTaskType: "Valitse tehtävän tyyppi",
        startTask: "Aloita tehtävä",
    },

    taskTransportingDialog: {
        taskTypeTitle: "Tehtävän tyyppi",
        leaveUnitsTitle: "Kyydistä jätetyt lavat",
        noLeaveUnits: "Ei lavojen vientiä.",
        takeUnitsTitle: "Kyytiin otetut lavat",
        noTakeUnits: "Ei lavojen noutoa.",
        findUnit: "Etsi lava",
        unitsMustBeProcessedBeforeAdvancing: "Käsittele lava/lavat ennen seuraavaa vaihetta!",
        externalUnit: "Ulkoinen lava",
        confirmIgnoringUnitProcessing: "Vahvista lavan käsittelemättä jättäminen",
        confirmWaybill: "Vahvista siirtoasiakirjan tiedot",
        editWaybill: "Muokkaa siirtoasiakirjaa",
    },

    taskDirection: {
        Deliver: "Vienti",
        Exchange: "Vaihto",
        Retrieve: "Nouto",
    },

    taskState: {
        New: "Uusi",
        Planned: "Suunniteltu",
        Started: "Aloitettu",
        Transporting: "Kuljetuksessa",
        Ready: "Valmis",
        Deferred: "Lykätty",
        Canceled: "Peruttu",
    },

    taskView: {
        addressFrom: "Mistä",
        addressTo: "Mihin",
        tasks: "Tehtävät",
        transportReference: "Tilauksen viite",
        noReference: "Ei viitettä",
        deviations: "Raportit",
        extraOrder: "eService-tilaus",
        attachments: "Liitteet",
        noAttachments: "Ei liitteitä",
        taskStarted: "Aloita",
        taskTransporting: "Asiakkaalta",
        taskReady: "Valmis",
        executionInfo: "Toteumatiedot",
        waybill: "Siirtoasiakirja",
        revertTask: "Palauta suunnitelluksi",
        addDeviation: "Raportoi tehtävästä",
        removeTask: "Poista tehtävä",
        planTask: "Suunnittele tehtävä",
        units: "Lavat",
        driversActions: "Kuljettajan valinnat",
        taskType: "Tehtävän tyyppi",
        id: "Id",
        type: "Tyyppi",
        direction: "Suunta",
        newLocation: "Uusi sijainti",
        contactPhone: "Tilauksen yhteyshenkilön puhelinnumero",
        onsitePhone: "Kohteen yhteyshenkilön puhelinnumero",
        orderDetails: "Tilauksen tiedot",
    },

    termsView: {
        acceptTerms: "Hyväksy käyttöehdot",
        termsAcceptedOn: "Käyttöehdot hyväksytty",
    },

    transportPartType: {
        KM: "km",
        PCS: "kpl",
        TIME: "Aika",
        TN: "tn",
        TRANSITION: "Siirtymä"
    },

    unitSelect: {
        noUnitsAtParty: "Paikassa ei ole lavoja.",
        showAllNUnits: "Näytä kaikki {0} lavaa",
    },

    validationErrors: {
        required: "Pakollinen",
    },

    vehicleCalendar: {
        selectDate: "Valitse päivä"
    },

    vehicleSelectDialog: {
        selectVehicle: "Valitse ajoneuvo",
        registerNumber: "Rekisterinumero",
        company: "Yritys",
    },

    waybill: {
        packagingType: "Pakkaustapa",
        quantity: "Määrä",
    },

    weekdays: {
        "0": "ma",
        "1": "ti",
        "2": "ke",
        "3": "to",
        "4": "pe",
        "5": "la",
        "6": "su",
    }
};
